import React from 'react';

interface ControlsInfoProps {
    controls?: string[];
    instructions?: string[];
    isPositioned?: boolean; // Whether to use absolute positioning
}

const ControlsInfo: React.FC<ControlsInfoProps> = ({
    controls = ['Use ARROW KEYS or WASD to move Pacman'],
    instructions = [
        'Collect all jungle fruits to advance to the next canopy',
        'Avoid the jungle spirits or eat power orbs to turn the tables!'
    ],
    isPositioned = false
}) => {
    const baseStyles = {
        color: '#F0F8FF',
        textAlign: 'center' as const,
        fontSize: '14px',
        fontWeight: '500'
    };

    const positionedStyles = isPositioned ? {
        position: 'absolute' as const,
        top: '210px', // Position below debug info
        left: '-240px',
        background: 'linear-gradient(135deg, rgba(0,100,0,0.9) 0%, rgba(34,139,34,0.8) 50%, rgba(85,107,47,0.7) 100%)',
        padding: '15px',
        borderRadius: '10px',
        // border: '2px solid #32CD32',
        boxShadow: '0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(50,205,50,0.3)',
        width: '180px',
        minWidth: '180px',
        textAlign: 'left' as const,
        animation: 'controlsGlow 2s ease-in-out infinite alternate'
    } : {
        marginTop: '20px',
        padding: '20px',
        background: 'linear-gradient(135deg, rgba(0,100,0,0.8) 0%, rgba(34,139,34,0.7) 50%, rgba(85,107,47,0.6) 100%)',
        borderRadius: '15px',
        border: '2px solid #32CD32',
        boxShadow: '0 8px 25px rgba(0,0,0,0.4), 0 0 15px rgba(50,205,50,0.2)',
        animation: 'controlsGlow 2s ease-in-out infinite alternate'
    };

    return (
        <div style={{ ...baseStyles, ...positionedStyles }}>
            <div style={{
                marginBottom: '15px',
                color: '#32CD32',
                fontWeight: 'bold',
                fontSize: '16px',
                textAlign: 'center',
                textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
                🎮 JUNGLE CONTROLS
            </div>
            {controls.map((control, index) => (
                <div key={index} style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(50,205,50,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(50,205,50,0.3)'
                }}>
                    {control}
                </div>
            ))}
            <div style={{
                marginTop: '20px',
                marginBottom: '15px',
                color: '#32CD32',
                fontWeight: 'bold',
                fontSize: '16px',
                textAlign: 'center',
                textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
                🎯 JUNGLE OBJECTIVE
            </div>
            {instructions.map((instruction, index) => (
                <div key={index} style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(34,139,34,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(34,139,34,0.3)'
                }}>
                    {instruction}
                </div>
            ))}

            <style>{`
                @keyframes controlsGlow {
                    0% { box-shadow: 0 8px 25px rgba(0,0,0,0.4), 0 0 15px rgba(50,205,50,0.2); }
                    100% { box-shadow: 0 8px 25px rgba(0,0,0,0.4), 0 0 25px rgba(50,205,50,0.4); }
                }
            `}</style>
        </div>
    );
};

export default ControlsInfo; 